import type { TransactionPredicate } from './types';
import { hasField } from './hasField';

export const hasAmountRoundupSaving = (): TransactionPredicate => hasField('amountRoundupSaving');
